import { h, Fragment } from "preact";
import StockStatusTooltip from "./stock-message-tooltip";

export default function StockMessageContent({ message, icon }) {
  const lines = message.lines.filter((line) => line.text);

  return (
    <div
      className="stock-message"
      data-elevar-stock-message={message.elevarName}
    >
      <input
        type="hidden"
        name="properties[_stock_status]"
        value={message.attributeValue}
      />
      {icon && (
        <img
          className="stock-message__icon"
          src={icon}
          alt=""
          width="24"
          height="24"
          loading="lazy"
        />
      )}
      <div className="stock-message__messages">
        {lines.map(({ text, color }, i) => (
          <div
            key={text}
            className={`stock-message__message stock-message__message--line-${i + 1}`}
            style={{ color }}
          >
            <div
              className="rte--simple"
              dangerouslySetInnerHTML={{
                __html: text,
              }}
            ></div>
            {i === lines.length - 1 && message.tooltip && (
              <StockStatusTooltip tooltip={message.tooltip} />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
